import { CatHeading } from "@blocks-react/components/Heading"

type translationProp = {
    subTotal: string,
    totalItems: string,
}

export type subTotalProps = {
    translations: translationProp,
    subtotal: string,
    totalItems: string
}

export const ServiceRecommendationSubTotal = ({ translations, subtotal, totalItems }: subTotalProps) => {
    return (
        <div slot="footer">
            <CatHeading variant="title-sm">
                {translations.subTotal} {subtotal}
            </CatHeading>
            <CatHeading variant="label">
                {translations.totalItems} {totalItems}
            </CatHeading>
        </div>
    )
}